export const Types = {
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  ppt: 'application/vnd.ms-powerpoint',
  potm: 'application/vnd.ms-powerpoint.template.macroEnabled.12',
  pptm: 'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
  ppam: 'application/vnd.ms-powerpoint.addin.macroEnabled.12',
  sldx: 'application/vnd.openxmlformats-officedocument.presentationml.slide',
  ppsx: 'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  potx: 'application/vnd.openxmlformats-officedocument.presentationml.template',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xlsm: 'application/vnd.ms-excel.sheet.macroEnabled.12',
  xlsb: 'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
  xltx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  docm: 'application/vnd.ms-word.document.macroEnabled.12',
  dotm: 'application/vnd.ms-word.template.macroEnabled.12',
  dotx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  doc: 'application/msword',
  zip: 'application/zip',
  '7z': 'application/x-7z-compressed',
  pdf: 'application/pdf',
  jpeg: 'image/jpeg',
  jpg: 'image/jpg',
  png: 'image/png',
  csv: 'text/csv',
  svg: 'image/svg+xml',
  dwg: 'image/x-dwg',
  dxf: 'image/x-dxf',
  dwf: 'drawing/x-dwf',
  mpeg: 'video/mpeg',
  mp4: 'video/mp4',
}
